// Temporary local helper - move to @grc/ui-utility once a long-month-name
// formatter is added there.
export const formatLongDate = (date: Date): string => {
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};
